import { store } from "@redux/store";
import { updateToIntialState1 } from "@redux/slices/CCP/step1Slice";
import { updateToIntialState2 } from "@redux/slices/CCP/step2Slice";
import { updateToIntialState3 } from "@redux/slices/CCP/step3Slice";
import { updateToIntialState4 } from "@redux/slices/CCP/step4Slice";
import { updateToIntialState6 } from "@redux/slices/CCP/step6Slice";

export function format(amount: number, flag = false) {
  if (amount <= 999 && !flag) {
    return amount.toString().replace(",", "");
  }
  //Convt number to string
  const amountString = amount.toString().split("");
  //check the len of string and add comma after every three digit from right end side
  const len = Math.floor(amountString.length / 3);
  //iterate through amount and add comma
  for (let i = 1; i <= len; i++) {
    let calc = -3 * i - (i - 1);
    if (calc <= -amountString.length) break;
    amountString.splice(-3 * i - (i - 1), 0, ",");
  }
  if (flag) {
    return amountString.join("");
  }
  return amountString.join("").concat(".00");
}

export function clearCCPStore() {
  store.dispatch(updateToIntialState1(""));
  store.dispatch(updateToIntialState2(""));
  store.dispatch(updateToIntialState3(""));
  store.dispatch(updateToIntialState4(""));
  store.dispatch(updateToIntialState6(""));
}
